export default __webpack_public_path__ + "static/2-f240ec135c8df32f72d98622670c00da.jpg";